import React from 'react';

import withDisplayName from 'bz-utilities/hoc/display-name';

export interface IProps {
  className?: string;
  value: string;
}

const CKEditorViewer = React.memo(
  withDisplayName<IProps>((props) => {
    const { className, value } = props;

    const _className = React.useMemo<string>(() => {
      const classes = [
        '[&_ul]:list-disc',
        '[&_ul]:pl-[40px]',
        '[&_ol]:list-decimal',
        '[&_ol]:pl-[40px]'
      ];

      return classes.addNotEmpty(className).toClassNames();
    }, [className]);

    return <div className={_className} dangerouslySetInnerHTML={{ __html: value }} />;
  }, 'CKEditorViewer')
);

export default CKEditorViewer;
